import * as React from "react"

export const ElectricBoltIcon: React.FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.69 2.20999L4.32997 11.49C3.68997 12.07 4.04997 13.14 4.90997 13.22L13 14L8.14997 20.76C7.92997 21.07 7.95997 21.5 8.22997 21.77C8.52997 22.07 8.99997 22.08 9.30997 21.79L19.67 12.51C20.31 11.93 19.95 10.86 19.09 10.78L11 9.99999L15.85 3.23999C16.07 2.92999 16.04 2.49999 15.77 2.22999C15.47 1.92999 15 1.91999 14.69 2.20999Z"
      fill="#616161"
    />
  </svg>
)
